// removed by extract-text-webpack-plugin
module.exports = {"content":"PayoutPreferencesPage__content__2kVbR","desktopTopbar":"PayoutPreferencesPage__desktopTopbar__1fidY","mobileTopbar":"PayoutPreferencesPage__mobileTopbar__30ryL","title":"PayoutPreferencesPage__title__3gzqt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PayoutPreferencesPage/PayoutPreferencesPage.css
// module id = 2359
// module chunks = 0